import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {HEART_SELECTED__16} from '@homeaway/svg-defs/lib/defs/HEART_SELECTED__16';
import {connect} from 'react-redux';
import actions from '../../../../tripboard/listing-delete-modal/actions';
import './HeartDeleteButton.less';
import edap from '../../../../tripboard/edap';

export function HeartDeleteButton({idx, hitTotal, listingId, boardId, open, deleteText}) {
    function handleModalOpen(event) {
        event.preventDefault();
        edap.listingDeleteModalOpen(boardId, listingId);
        edap.heartClicked(boardId, 'off');
        open({boardId, hitTotal, idx, listingId});
        event.stopPropagation();
    }
    return (
        <div
            aria-label={deleteText}
            role="button"
            className="heart-delete-button card__close hidden-mini"
            onClick={handleModalOpen}
            onKeyPress={handleModalOpen}
            data-wdio="tripboard-details__listing--delete"
            tabIndex="0"
        >
            <span className="heart-delete-button__circle">
                <SVGIcon className="text-danger" inlineFlex markup={HEART_SELECTED__16}/>
            </span>
        </div>
    );
}

HeartDeleteButton.defaultProps = {
    open: () => {}
};

export const mapDispatchToProps = {
    open: actions.open
};

export default connect(null, mapDispatchToProps)(HeartDeleteButton);



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HeartDeleteButton/HeartDeleteButton.js